import { InitialPeriod, MortgagePreferences } from "models/ApplicationSummaryEnhanced"
import React from "react"

interface InitialPeriodCopyProps {
  preference: MortgagePreferences["initialPeriod"]
}
export const InitialPeriodCopy = ({
  preference: { customReason: reason, period },
}: InitialPeriodCopyProps) => {
  switch (period) {
    case InitialPeriod.OneYear:
      return (
        <>
          A <strong>1-year deal</strong> has been recommended because {reason}
        </>
      )
    case InitialPeriod.TwoYears:
      return (
        <>
          A <strong>2-year deal</strong> has been recommended because {reason}
        </>
      )
    case InitialPeriod.ThreeYears:
      return (
        <>
          A <strong>3-year deal</strong> has been recommended because {reason}
        </>
      )
    case InitialPeriod.FiveYears:
      return (
        <>
          A <strong>5-year deal</strong> has been recommended because {reason}
        </>
      )
    case InitialPeriod.SevenYears:
      return (
        <>
          A <strong>7-year deal</strong> has been recommended because {reason}
        </>
      )
    case InitialPeriod.TenYears:
      return (
        <>
          A <strong>10-year deal</strong> has been recommended because {reason}
        </>
      )
    case InitialPeriod.OverTenYears:
      return (
        <>
          A <strong>deal over 10 years</strong> has been recommended because {reason}
        </>
      )
    case InitialPeriod.ERCFree:
      return (
        <>
          An <strong>ERC free deal</strong> has been recommended because {reason}
        </>
      )
    default:
      return null
  }
}
